import { render } from "./AppCheckbox.vue?vue&type=template&id=07b72113&scoped=true"
import script from "./AppCheckbox.vue?vue&type=script&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&lang=js"

import "./AppCheckbox.vue?vue&type=style&index=0&id=07b72113&scoped=true&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b72113"]])

export default __exports__